import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "icn-graphics-duration",
  templateUrl: "./duration.html",
  styleUrls: ["./duration.scss"],
})
export class GraphicsDurationComponent {
  constructor() {}

  step;
  minValue;
  maxValue;
  newDuration;

  @Output()
  updateDurationMS = new EventEmitter<number>();

  @Input() durationValues: {
    duration: number;
    startLoop: number;
    endLoop: number;
    step: number;
  };

  ngOnInit() {
    /*this.minValue = this.durationValues.duration / 1000;
        this.maxValue = this.durationValues.duration;
        this.step = !this.durationValues.step ? 0.1 : this.durationValues.step / 1000;
        this.newDuration = this.durationValues.duration / 1000;*/
    this.minValue = 0.1;
    this.maxValue = 86400;
    this.step = 0.1;
    this.newDuration = this.durationValues.duration / 1000;
  }

  onValueChange(newVal: number) {
    this.newDuration = newVal;
    this.durationValues.duration = newVal * 1000;
    this.updateDurationMS.next(this.durationValues.duration);
  }
}
